import Slider from "./common/classes/slider.es6";

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        const keywordSlider = document.querySelector(".js-keyword-slider");
        const keywordSliderThumb = document.querySelector(".js-keyword-slider-thumb");
        if(!keywordSlider || !keywordSliderThumb) return;

        const thumboption = {
            slidesPerView: "auto",
            watchSlidesProgress: true,
            slideToClickedSlide: true,
        };
        const swiperthumb = new Slider(keywordSliderThumb, thumboption);
        const options = {
            loop: true,
            slidesPerView: 1,
            navigation: {
                nextEl: ".js-keyword-next",
                prevEl: ".js-keyword-prev",
            },
            centeredSlides: true,
            thumbs: { swiper: swiperthumb.swiperInstance },
        };

        const swiper = new Slider(keywordSlider, options);

        // サムネイルのクリックはモーダルオープン処理と競合するため、
        // swiper-slideのインデックスを取得してメインスワイパーを同期させる
        const thumbSlides = [...keywordSliderThumb.querySelectorAll(".swiper-slide")];
        const modal = document.querySelector('.js-modal[data-modalID="imagemodal"]');

        thumbSlides.forEach((slide, index) => {
            slide.addEventListener("click", () => {
                const swiperInst = swiper.swiperInstance;
                const originalSpeed = swiperInst.params.speed;

                // モーダルを開く瞬間はtransitionなしでジャンプ
                swiperInst.params.speed = 0;
                swiperInst.slideToLoop(index, 0, false);

                // モーダルのフェードイン完了後にspeedを復元
                if (modal) {
                    const restore = (e) => {
                        if (e.target !== modal) return;
                        swiperInst.params.speed = originalSpeed;
                        modal.removeEventListener("transitionend", restore);
                    };
                    modal.addEventListener("transitionend", restore);
                }
            });
        });
    }
}

const main = new Main();
